const thankYou = {
    title: 'Thank You',
    header: 'Thank you for reaching out',
    message: 'I will look into your inquiry and get back to you shortly.',
    link: 'Home',
}

export default thankYou
